<template>
  <div class="c-form-wrap" v-bind:class="ComputedClass">
    <label class="c-form-wrap__field-name">{{label}}</label>

    <div class="c-form-wrap__field-wrap">
      <div class="c-form-wrap__input-wrap">
        <input class="c-form-wrap__input"
               v-model="localValue"
               @focus="focus"
               @focusout="focusOut"
               v-validate="passwordValidation"
               :name="fieldName"
               :data-vv-name="fieldName"
               :autocomplete="autocompleteField"
               :type="fieldType"

               >
      </div>
        <svg v-on:click="showPassword" :class="EyeClass" class="c-form-wrap__show-icon"  width="31px" height="21px" viewBox="0 0 31 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g class="c-form-wrap__eye-open" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path class="c-form-wrap__eye-open--background" d="M14.9826903,21 C23.2811435,21 30,11 30,11 C30,11 23.2811435,1 14.9826903,1 C6.68423715,1 0,11 0,11 C0,11 6.68423715,21 14.9826903,21 Z"   ></path>
                <circle class="c-form-wrap__eye-open--pupil"  cx="15" cy="11" r="6"></circle>
                <path class="c-form-wrap__eye-open--eyebrow" d="M1,1 C1,1 7.23862134,9 14.9838443,9 C22.7290673,9 29,1 29,1"  transform="translate(15.000000, 5.000000) scale(1, -1) translate(-15.000000, -5.000000)"></path>
            </g>
            <g class="c-form-wrap__eye-close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path class="c-form-wrap__eye-close--background" d="M15.0120168,20 C23.296288,20 30.0036621,10 30.0036621,10 C30.0036621,10 23.296288,0 15.0120168,0 C6.72774553,0 0.0549316406,10 0.0549316406,10 C0.0549316406,10 6.72774553,20 15.0120168,20 Z" ></path>
                <path class="c-form-wrap__eye-close--eyebrow" d="M1.47180176,11 C1.47180176,11 7.48875752,19 14.9587836,19 C22.4288096,19 28.4769287,11 28.4769287,11"></path>
            </g>
        </svg>
    </div>

      <span class="c-form-wrap__tooltip">
            <span class="c-form-wrap__hidden">
                <template v-if="isError && !focusField">
                    <template v-if="externalError.haveError">
                        {{externalError.errorText}}
                    </template>
                    <template v-else>
                        {{ errors.first(fieldName)}}
                    </template>
                </template>
                <template v-else>

                    <slot name="hint"></slot>
                </template>
            </span>
            <slot name="tooltip"></slot>
        </span>
  </div>
</template>

<script>
  import { STATUSES } from "../statuses";
  import cInput from "./input"
  export default {
    name: "cInputPassword",
    extends: cInput,
    props: {
    },
    data() {
      return {
        passwordValidation:'required|min:8',
        fieldType: 'password'
      };
    },
    methods: {
        showPassword() {
            this.fieldType = this.fieldType === "password" ? "text" : "password";
        }
    },
    computed: {
        autocompleteField(){
            if(this.fieldName !== 'password'){
                return 'false'
            }else{
                return null;
            }
        },
        isShow() {
            return this.fieldType === "text";
        },
        EyeClass: function() {
            return {
                "c-form-wrap__show-icon--show": this.isShow
            };
        }
    }
  };
</script>

<style lang="scss">
  @import "~@/assets/scss/variable";

  .c-form-wrap{
      $blockname: &;
      #{$blockname}__show-icon {
          position: absolute;
          right: 10px;
          top: 25%;
      }
      #{$blockname}__eye-open {
          &--background {
              fill: #9b9b9b;
              opacity: 0.3;
          }
          &--pupil {
              fill: #333333;
              opacity: 0.497209821;
          }
          &--eyebrow {
              stroke: #333333;
              stroke-width: 2px;
              stroke-linecap: round;
          }
      }
      #{$blockname}__eye-close {
          &--background {
              fill: #333333;
              opacity: 0.3;
          }
          &--eyebrow {
              stroke: #333333;
              stroke-width: 2px;
              stroke-linecap: round;
          }
      }
  }
  .c-form-wrap__show-icon {
      &:hover {
          cursor: pointer;
      }
      .c-form-wrap__eye-open {
          display: none;
      }
      &--show {
          .c-form-wrap__eye-open {
              display: block;
          }
          .c-form-wrap__eye-close {
              display: none;
          }
      }
  }
  .c-form-wrap {
      $blockname: &;

      &.c-form-wrap--focus {
          #{$blockname}__show-icon {
              position: absolute;
              right: 10px;
              top: 25%;
          }
          #{$blockname}__eye-open {
              &--background {
                  fill: #93278f;
                  opacity: 0.3;
              }
              &--pupil {
                  fill: #93278f;
                  opacity: 0.497209821;
              }
              &--eyebrow {
                  stroke: #93278f;
                  stroke-width: 2px;
                  stroke-linecap: round;
              }
          }
          #{$blockname}__eye-close {
              &--background {
                  fill: #ffb700;
                  opacity: 0.3;
              }
              &--eyebrow {
                  stroke: #93278f;
                  stroke-width: 2px;
                  stroke-linecap: round;
              }
          }
      }
      &.c-form-wrap--filled {
          #{$blockname}__show-icon {
              position: absolute;
              right: 10px;
              top: 25%;
          }
          #{$blockname}__eye-open {
              &--background {
                  fill: #93278f;
                  opacity: 0.3;
              }
              &--pupil {
                  fill: #93278f;
                  opacity: 0.497209821;
              }
              &--eyebrow {
                  stroke: #93278f;
                  stroke-width: 2px;
                  stroke-linecap: round;
              }
          }
          #{$blockname}__eye-close {
              &--background {
                  fill: #ffb700;
                  opacity: 0.3;
              }
              &--eyebrow {
                  stroke: #93278f;
                  stroke-width: 2px;
                  stroke-linecap: round;
              }
          }
      }
  }

</style>
